module.exports = __webpack_public_path__ + "add64ffa6ab2e5cb951ff93f81208a67.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/beers/images/exclusive_green.png
// module id = kOnl
// module chunks = 0